export default "__VITE_ASSET__C0YQ$1lJ__"